/* eslint-disable import/no-unresolved */
import { arrayOf, bool, func, number, shape, string } from "prop-types";
import React, { Component, Fragment } from "react";
import Col from "react-bootstrap/lib/Col";
import { connect } from "react-redux";
import { routerActions } from "react-router-redux";
import { actions as accountsActions, selectors as accountsSelectors } from "reducers/accounts";
import { actions as debinActions, selectors as debinSelectors } from "reducers/debin";
import { selectors as sessionSelectors } from "reducers/session";
import * as accountUtils from "util/accounts";
import { isPullTrx, statusTagColor } from "util/debin";
import * as i18nUtils from "util/i18n";
import moment from "moment";

import Button from "pages/_components/Button";
import Container from "pages/_components/Container";
import FormattedAmount from "pages/_components/FormattedAmount";
import FormattedDate from "pages/_components/FormattedDate";
import Head from "pages/_components/Head";
import Heading from "pages/_components/Heading";
import I18n from "pages/_components/I18n";
import InfoTag from "pages/_components/InfoTag";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import PageLoading from "pages/_components/PageLoading";
import { resizableRoute } from "pages/_components/Resizable";
import Hint from "pages/_components/hints/Hint";
import * as configUtils from "util/config";
import { applyEmbeddedV3ShellLayoutState, clearEmbeddedV3ShellLayoutState } from "util/v3ShellLayoutSync";
import { isValidCVU } from "util/credin";
import { TransfersPullDrawer } from "@ui-kit/components/index.es";
import IncomingDebinModal from "./IncomingDebinModal";

class IncomingDebinDetail extends Component {
    static propTypes = {
        fetching: bool,
        fetchingAccounts: bool,
        match: shape({
            params: shape({
                idSignature: string,
            }),
        }),
        dispatch: func.isRequired,
        debinDetail: shape({
            id: string,
        }).isRequired,
        buyerDetail: shape({}).isRequired,
        accounts: shape({}),
        loggedUser: shape({
            accessToken: string,
            defaultAvatarId: string,
            email: string,
            previousLoginInfo: arrayOf(
                shape({
                    city: string,
                    country: string,
                    date: string,
                    idUser: string,
                    ip: string,
                    latitude: number,
                    longitude: number,
                }),
            ),
            securitySeal: number,
            userFullName: string,
        }),
        isDesktop: bool.isRequired,
        location: shape({
            state: string.isRequired,
        }).isRequired,
        isRetailEnvironment: bool.isRequired,
        embeddedInV3Shell: bool,
    };

    static defaultProps = {
        embeddedInV3Shell: false,
        fetching: false,
        fetchingAccounts: false,
        match: null,
        accounts: null,
        loggedUser: null,
    };

    state = {
        modalDisplayed: false,
        chargebackPullDrawerVisible: false,
    };

    componentDidMount() {
        const {
            dispatch,
            match: {
                params: { idDebin },
            },
            accounts,
            loggedUser,
        } = this.props;
        dispatch(debinActions.acceptIncomingRequestPre(idDebin));

        if (!accounts.length > 0) {
            dispatch(accountsActions.listAccounts(loggedUser.userId));
        }
        this.syncEmbeddedV3ShellLayout();
    }

    componentDidUpdate(prevProps) {
        const { debinDetail, accounts, embeddedInV3Shell, isDesktop } = this.props;
        if (debinDetail && prevProps.debinDetail !== debinDetail) {
            const { dispatch } = this.props;
            const { buyerDetail } = debinDetail;
            const loggedUserAccount = accountUtils.getUserAccount(accounts, buyerDetail?.cbu);
            const accountName = accountUtils.getIncomingDebinAccountName(loggedUserAccount);
            dispatch(debinActions.loadAccountName(accountName));
        }
        if (
            embeddedInV3Shell &&
            (prevProps.embeddedInV3Shell !== embeddedInV3Shell || prevProps.isDesktop !== isDesktop)
        ) {
            this.syncEmbeddedV3ShellLayout();
        }
    }

    componentWillUnmount() {
        const { embeddedInV3Shell, dispatch } = this.props;
        if (embeddedInV3Shell) {
            clearEmbeddedV3ShellLayoutState(dispatch);
        }
    }

    syncEmbeddedV3ShellLayout = () => {
        const { dispatch, embeddedInV3Shell, isDesktop } = this.props;
        applyEmbeddedV3ShellLayoutState(dispatch, {
            embeddedInV3Shell,
            isDesktop,
            scopes: ["debin"],
            titleKey: "payments.debin.detail.header.label.mobile",
            goBackPath: "/payments/payDebin",
        });
    };

    handleBack = () => {
        const { dispatch, isDesktop } = this.props;
        if (!isDesktop) {
            dispatch(debinActions.cleanIncomingDebin());
        }
        dispatch(routerActions.goBack());
    };

    handleAccept = () => {
        const { dispatch } = this.props;
        dispatch(routerActions.push("/payments/payDebin/accept/confirm"));
    };

    handleDecline = () => {
        const { dispatch } = this.props;

        dispatch(routerActions.push("/payments/payDebin/decline/confirm"));
    };

    handleChargeback = () => {
        const { dispatch } = this.props;
        dispatch(routerActions.push("/payments/payDebin/chargeback/confirm"));
    };

    handleSetDrawerOpen = (open) => {
        this.setState({ chargebackPullDrawerVisible: open });
    };

    handleChargebackPullSubmit = (values) => {
        const { dispatch } = this.props;
        const { reason } = values;
        dispatch(debinActions.loadChargebackPullReason(reason));
        this.setState({ chargebackPullDrawerVisible: false });
        dispatch(routerActions.push("/payments/payDebin/chargebackPull/confirm"));
    };

    getChargebackPullDrawerTexts = (key) => {
        const texts = {
            title: i18nUtils.get("payments.debin.chargebackPull.drawer.title"),
            text: i18nUtils.get("payments.debin.chargebackPull.drawer.text"),
            reason: i18nUtils.get("payments.debin.chargebackPull.drawer.reason"),
            submit: i18nUtils.get("global.continue"),
            btn: i18nUtils.get("payments.debin.chargebackPull.drawer.btn"),
        };
        return texts[key] || "";
    };

    handleModal = () => {
        const { location } = this.props;
        const idTransaction = location.state?.idTransaction;

        if (configUtils.getBoolean("frontend.show.pendingDebin.functionalities") && idTransaction) {
            const { dispatch } = this.props;
            dispatch(debinActions.acceptIncomingRequestPrePending(idTransaction));
        } else {
            this.setState({ modalDisplayed: true });
        }
    };

    handleCancel = (e) => {
        e.preventDefault();
        this.setState({ modalDisplayed: false });
    };

    centerContentMobile = () => (
        <div className="title-account-header-multiline-background-blue">
            <I18n id="payments.debin.detail.header.label.mobile" component="h1" />
        </div>
    );

    getDebitAccount = () => {
        const {
            debinDetail: { buyerDetail },
            accounts,
        } = this.props;
        return accountUtils.getUserAccount(accounts, buyerDetail?.cbu);
    };

    shouldShowChargeback = () => {
        const chargeBackEnabled = configUtils.getBoolean("frontend.show.programedDebin.chargeback.enable", false);

        const {
            debinDetail: { description, devolution },
        } = this.props;
        return chargeBackEnabled && !devolution && description && this.isScheduled(description);
    };

    showChargebackPull = () => {
        const chargeBackPullEnabled = configUtils.getBoolean(
            "frontend.show.chargeback.transferenciapull.enable",
            false,
        );

        const {
            debinDetail: { devolution, creationDate, type },
            isRetailEnvironment,
        } = this.props;

        const isWithin60Days = () => {
            if (!creationDate) {
                return false;
            }

            const now = moment();
            const creationDateTime = moment(creationDate);
            const diffInDays = now.diff(creationDateTime, "days");
            return diffInDays < 60;
        };
        const typeDebin = () => {
            if (type !== "TRXPL") {
                return false;
            }
            return true;
        };
        return (
            chargeBackPullEnabled &&
            !devolution &&
            creationDate &&
            isWithin60Days() &&
            isRetailEnvironment &&
            typeDebin()
        );
    };

    isScheduled = (description) => /^001\/\d{3}$/.test(description);

    getDebinTitle = () => {
        const {
            debinDetail: {
                id,
                status: { code },
                buyerDetail,
                preAutorizado,
                description,
                type,
            },
            accounts,
            isDesktop,
        } = this.props;
        const { cbu } = buyerDetail;
        const name = `${i18nUtils.get("payments.debin.detail.header.label ")} ${id}`.toUpperCase();
        const loggedUserAccount = accountUtils.getUserAccount(accounts, cbu);
        const accountName =
            accountUtils.getIncomingDebinAccountName(loggedUserAccount) ||
            accountUtils.maskedAccountNumber(cbu.substring(cbu.length - 8));

        const isScheduled = this.isScheduled(description);

        if (!code) {
            return <></>;
        }

        let tagMessage;
        if (isScheduled) {
            tagMessage = i18nUtils.get("debin.recurrency.tag.scheduled");
        } else if (isPullTrx(type)) {
            tagMessage = i18nUtils.get("debin.recurrency.tag.pull");
        } else {
            tagMessage = i18nUtils.get("debin.recurrency.tag.recurrent");
        }

        return (
            <>
                {isDesktop ? (
                    <>
                        <div className="view-title data-wrapper-flex">
                            <h1 className="my-0 mr-3">{name}</h1>
                            {preAutorizado && (
                                <InfoTag
                                    type="info"
                                    message={tagMessage}
                                    tagBackground="#000"
                                    tagClass="align-self-end my-2 mr-3 ml-0"
                                    moreStyles={{ color: "white" }}
                                />
                            )}
                            <InfoTag
                                type="info"
                                message={code}
                                tagBackground={statusTagColor(code, preAutorizado)}
                                tagClass="mx-0"
                                moreStyles={{ color: "black" }}
                            />
                        </div>
                        <div className="d-flex my-1">
                            <p className="font-bold my-0 mr-2">
                                {i18nUtils.get(`debin.create.summary.debitAccount.label`)}
                            </p>
                            <p className="my-0">{accountName}</p>
                        </div>
                    </>
                ) : (
                    <div className="view-title data-wrapper my-0 mx-3">
                        <h3 className="mt-3 mb-0">{name}</h3>
                        <p className="font-bold m-0">{i18nUtils.get(`debin.create.summary.debitAccount.label`)}</p>
                        <p className="mt-0">{accountName}</p>
                        <div className="d-flex">
                            {preAutorizado && (
                                <InfoTag
                                    type="info"
                                    message={tagMessage}
                                    tagBackground="#000"
                                    tagClass="align-self-end my-2 mr-3 ml-0"
                                    moreStyles={{ color: "white" }}
                                />
                            )}
                            <InfoTag
                                type="info"
                                message={code}
                                tagBackground={statusTagColor(code)}
                                moreStyles={{
                                    alignSelf: "flex-start",
                                    width: "min-content",
                                    color: "black",
                                    margin: "0.5rem 0",
                                }}
                            />
                        </div>
                    </div>
                )}
            </>
        );
    };

    renderPageHeader = () => {
        const { isDesktop, debinDetail, embeddedInV3Shell } = this.props;
        const { modalDisplayed, chargebackPullDrawerVisible } = this.state;
        const { status, sellerDetail } = debinDetail;

        const isValidCVUSeller = isValidCVU(sellerDetail.cbu);
        const isDebinCVUSignatureActive = configUtils.getBoolean("frontend.esquemaFirmas.validation.debinCVU.enable");

        if (isDesktop) {
            return (
                <>
                    {!embeddedInV3Shell && <Notification scopeToShow="debin" />}
                    <IncomingDebinModal
                        isDisplayed={modalDisplayed}
                        isDesktop={isDesktop}
                        acceptClick={this.handleAccept}
                        cancelClick={this.handleCancel}
                    />
                    <div className="admin-detail-head px-0">
                        <Head onBack={this.handleBack} />
                        {(() => {
                            if (
                                !debinDetail.preAutorizado &&
                                this.getDebitAccount() &&
                                status.code.toUpperCase() === "INICIADO"
                            ) {
                                return (
                                    <>
                                        <Head
                                            handleAcceptDebinClick={this.handleModal}
                                            handleDeclineDebinClick={() => this.handleDecline()}
                                            hasInlineButtons
                                            centerElement={this.getDebinTitle}
                                            centerContentClassName="d-flex flex-column align-items-start"
                                            acceptDebinCVUButton={isValidCVUSeller && isDebinCVUSignatureActive}
                                        />
                                        <Hint
                                            alwaysShowMessage
                                            classNameHintP="mt-0"
                                            nodeMessage={
                                                <I18n
                                                    id=""
                                                    defaultValue={configUtils.get("DEBIN.requestreceived.text")}
                                                    component="p"
                                                    componentProps={{ className: "hint-text hint-text-header" }}
                                                />
                                            }
                                        />
                                    </>
                                );
                            }
                            if (
                                this.getDebitAccount() &&
                                status.code.toUpperCase() === "ACREDITADO" &&
                                this.shouldShowChargeback()
                            ) {
                                return (
                                    <Head
                                        handleChargebackDebinClick={() => this.handleChargeback()}
                                        hasInlineButtons
                                        centerElement={this.getDebinTitle}
                                        centerContentClassName="d-flex flex-column align-items-start"
                                    />
                                );
                            }
                            if (
                                this.getDebitAccount() &&
                                status.code.toUpperCase() === "ACREDITADO" &&
                                this.showChargebackPull()
                            ) {
                                return (
                                    <Head
                                        rightContent={() => (
                                            <>
                                                <TransfersPullDrawer
                                                    isVisible={chargebackPullDrawerVisible}
                                                    getTexts={this.getChargebackPullDrawerTexts}
                                                    setOpen={this.handleSetDrawerOpen}
                                                    onSubmit={this.handleChargebackPullSubmit}
                                                    validations={null}
                                                    loading={false}
                                                />
                                            </>
                                        )}
                                        hasInlineButtons
                                        centerElement={this.getDebinTitle}
                                        centerContentClassName="d-flex flex-column align-items-start"
                                    />
                                );
                            }
                            return (
                                <Head
                                    centerElement={this.getDebinTitle}
                                    centerContentClassName="d-flex flex-column align-items-start"
                                />
                            );
                        })()}
                    </div>
                </>
            );
        }
        return (
            <>
                {!embeddedInV3Shell && <Notification scopeToShow="debin" />}
                {!(embeddedInV3Shell && !isDesktop) && (
                    <div className="px-0 mb-0">
                        <Head
                            onBack={this.handleBack}
                            headerClassName="blue-main-header-mobile"
                            centerElement={this.centerContentMobile}
                            emptyRightOption
                        />
                        {this.getDebinTitle()}
                    </div>
                )}
            </>
        );
    };

    renderContent = () => {
        const {
            debinDetail: {
                amount: { currency, quantity },
                concept,
                description,
                expirationDate,
                idVoucher,
                sellerDetail,
                creationDate,
                reference,
                type,
            },
            debinDetail: { amount, preAutorizado, status },
            isDesktop,
        } = this.props;

        const showChargeback = this.shouldShowChargeback();
        const isScheduled = this.isScheduled(description);

        const isValidCVUSeller = isValidCVU(sellerDetail.cbu);
        const isDebinCVUSignatureActive = configUtils.getBoolean("frontend.esquemaFirmas.validation.debinCVU.enable");

        const { modalDisplayed, chargebackPullDrawerVisible } = this.state;

        const containerClassName = `transfer-data ${
            !isDesktop ? "data-wrapper-flex space-between mb-0 debin-detail" : "data-wrapper"
        }`;

        let sellerBankInfo = sellerDetail.bank;
        if (!sellerDetail.cbu.startsWith("000")) {
            sellerBankInfo += ` / ${sellerDetail.branch}`;
        }

        return (
            <Fragment>
                {this.renderPageHeader()}
                <MainContainer>
                    <div className="above-the-fold">
                        <Container
                            className="flex-grow container-white my-2 with-padding"
                            style={{ textTransform: "uppercase" }}>
                            <Col className="col col-12" md={3} xl={3} lg={3} sm={12}>
                                <Heading.DataGroup
                                    containerClassName={containerClassName}
                                    label="payments.debin.detail.table.header.amount"
                                    data={
                                        amount ? (
                                            <FormattedAmount currency={currency} quantity={quantity} notBold="true" />
                                        ) : (
                                            "-"
                                        )
                                    }
                                />
                            </Col>
                            <Col className="col col-12" md={3} xl={3} lg={3} sm={12}>
                                <Heading.DataGroup
                                    containerClassName={containerClassName}
                                    label="payments.debin.detail.table.header.concept"
                                    data={concept ? i18nUtils.get(`transfers.concept.${concept}`) : "-"}
                                />
                            </Col>
                            <Col className="col col-12" md={3} xl={3} lg={3} sm={12}>
                                <Heading.DataGroup
                                    containerClassName={containerClassName}
                                    label={
                                        this.isScheduled(description)
                                            ? "payments.debin.detail.table.header.installment"
                                            : "payments.debin.detail.table.header.description"
                                    }
                                    data={description || "-"}
                                />
                            </Col>
                            <Col className="col col-12" md={3} xl={3} lg={3} sm={12}>
                                <Heading.DataGroup
                                    containerClassName={containerClassName}
                                    label="payments.debin.detail.table.header.expirationDate"
                                    data={
                                        expirationDate ? (
                                            <FormattedDate date={expirationDate} dateFormat="dd/MM/yyyy" showTime />
                                        ) : (
                                            "-"
                                        )
                                    }
                                />
                            </Col>
                        </Container>
                        <Container
                            className="flex-grow container-white my-2 with-padding"
                            style={{ textTransform: "uppercase" }}>
                            <Col className="col col-12" md={3} xl={3} lg={3} sm={12}>
                                <Heading.DataGroup
                                    containerClassName={containerClassName}
                                    label="payments.debin.detail.table.header.voucher"
                                    data={idVoucher || "-"}
                                />
                            </Col>
                            <Col className="col col-12" md={3} xl={3} lg={3} sm={12}>
                                <Heading.DataGroup
                                    containerClassName={containerClassName}
                                    label="payments.debin.detail.table.header.sender"
                                    data={sellerDetail.titular || "-"}
                                />
                            </Col>
                            <Col className="col col-12" md={3} xl={3} lg={3} sm={12}>
                                <Heading.DataGroup
                                    containerClassName={containerClassName}
                                    label="payments.debin.detail.table.header.documentType"
                                    data={
                                        (
                                            <div>
                                                <span style={{ marginRight: "0.5rem" }}>
                                                    {sellerDetail.documentType}
                                                </span>
                                                <span>{sellerDetail.documentNumber}</span>
                                            </div>
                                        ) || "-"
                                    }
                                />
                            </Col>
                            <Col className="col col-12" md={3} xl={3} lg={3} sm={12}>
                                <Heading.DataGroup
                                    containerClassName={containerClassName}
                                    label="payments.debin.detail.table.header.creationDate"
                                    data={
                                        creationDate ? (
                                            <FormattedDate date={creationDate} dateFormat="dd/MM/yyyy" showTime />
                                        ) : (
                                            "-"
                                        )
                                    }
                                />
                            </Col>
                        </Container>
                        <Container
                            className="flex-grow container-white my-2 with-padding"
                            style={{ textTransform: "uppercase" }}>
                            <Col className="col col-12" md={3} xl={3} lg={3} sm={12}>
                                <Heading.DataGroup
                                    containerClassName={containerClassName}
                                    label={`payments.debin.detail.table.header.${(() => {
                                        const isCVU = sellerDetail?.cbu?.startsWith("000");
                                        if (this.isScheduled(description) || isPullTrx(type)) {
                                            return isCVU ? "chargeback.cvu" : "chargeback.cbu";
                                        }
                                        return isCVU ? "cvu" : "cbu";
                                    })()}`}
                                    data={sellerDetail.cbu || "-"}
                                />
                            </Col>
                            <Col className="col col-12" md={3} xl={3} lg={3} sm={12}>
                                <Heading.DataGroup
                                    containerClassName={containerClassName}
                                    label={
                                        this.isScheduled(description)
                                            ? "payments.debin.detail.table.header.chargeback.alias"
                                            : "payments.debin.detail.table.header.alias"
                                    }
                                    data={sellerDetail.cbuAlias || "-"}
                                />
                            </Col>
                            <Col className="col col-12" md={3} xl={3} lg={3} sm={12}>
                                <Heading.DataGroup
                                    containerClassName={containerClassName}
                                    label={`payments.debin.detail.table.header.${
                                        sellerDetail?.cbu?.startsWith("000") ? "entity" : "branch"
                                    }`}
                                    data={sellerBankInfo}
                                />
                            </Col>
                            <Col className="col col-12" md={3} xl={3} lg={3} sm={12}>
                                <Heading.DataGroup
                                    containerClassName={containerClassName}
                                    label="payments.debin.detail.table.header.reference"
                                    data={reference || "-"}
                                />
                            </Col>
                        </Container>
                        {preAutorizado && !isScheduled && !isPullTrx(type) && (
                            <Container
                                className="container--layout flex-grow align-items-center"
                                gridClassName="form-content">
                                <Col md={6} sm={12}>
                                    <Hint
                                        idMessage="debin.recurrency.reverse.charge.hint"
                                        styleText={{ maxWidth: "100%" }}
                                        styleImage={{ alignSelf: "center", marginTop: "0.7rem" }}
                                        classNameHintP="hint-font-size-small"
                                        alwaysShowMessage
                                    />
                                </Col>
                            </Container>
                        )}
                    </div>
                    {!isDesktop &&
                        !preAutorizado &&
                        this.getDebitAccount() &&
                        status.code.toUpperCase() === "INICIADO" && (
                            <>
                                <IncomingDebinModal
                                    isDisplayed={modalDisplayed}
                                    isDesktop={isDesktop}
                                    acceptClick={this.handleAccept}
                                    cancelClick={this.handleCancel}
                                />
                                <Container
                                    className="container--layout flex-grow align-items-center"
                                    gridClassName="form-content">
                                    <Col sm={12} md={9} lg={7} xl={7} className="col col-12 align-items-center">
                                        <Col
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                flexDirection: "column-reverse",
                                            }}
                                            sm={12}
                                            className="col col-12 col-no-pad-mobile">
                                            <Button
                                                bsStyle="outline"
                                                onClick={() => this.handleDecline()}
                                                label="payments.debin.table.menu.decline"
                                                style={{ marginTop: "0.25rem", marginBottom: "0.25rem" }}
                                            />
                                            <Button
                                                bsStyle="primary"
                                                style={{
                                                    marginTop: "0.25rem",
                                                    marginBottom: "0.25rem",
                                                }}
                                                onClick={this.handleModal}
                                                label={
                                                    isValidCVUSeller && isDebinCVUSignatureActive
                                                        ? "payments.debinCVU.table.menu.accept"
                                                        : "payments.debin.table.menu.accept"
                                                }
                                            />
                                        </Col>
                                    </Col>
                                </Container>
                            </>
                        )}
                    {!isDesktop &&
                        this.getDebitAccount() &&
                        status.code.toUpperCase() === "ACREDITADO" &&
                        showChargeback && (
                            <Container
                                className="container--layout flex-grow align-items-center"
                                gridClassName="form-content">
                                <Col sm={12} md={9} lg={7} xl={7} className="col col-12 align-items-center">
                                    <Col
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            flexDirection: "column",
                                        }}
                                        sm={12}
                                        className="col col-12 col-no-pad-mobile">
                                        <Button
                                            bsStyle="primary"
                                            onClick={() => this.handleChargeback()}
                                            label="payments.debin.table.menu.chargeback"
                                            style={{ marginTop: "0.25rem", marginBottom: "0.25rem" }}
                                        />
                                    </Col>
                                </Col>
                            </Container>
                        )}
                    {!isDesktop &&
                        this.getDebitAccount() &&
                        status.code.toUpperCase() === "ACREDITADO" &&
                        this.showChargebackPull() && (
                            <Container
                                className="container--layout flex-grow align-items-center"
                                gridClassName="form-content">
                                <Col sm={12} md={9} lg={7} xl={7} className="col col-12 align-items-center">
                                    <Col
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            flexDirection: "column",
                                        }}
                                        sm={12}
                                        className="col col-12 col-no-pad-mobile">
                                        <Button
                                            bsStyle="primary"
                                            onClick={() => this.handleSetDrawerOpen(true)}
                                            label="payments.debin.chargebackPull.drawer.btn"
                                            style={{ marginTop: "0.25rem", marginBottom: "0.25rem" }}
                                        />
                                        <>
                                            <TransfersPullDrawer
                                                isVisible={chargebackPullDrawerVisible}
                                                getTexts={this.getChargebackPullDrawerTexts}
                                                setOpen={this.handleSetDrawerOpen}
                                                onSubmit={this.handleChargebackPullSubmit}
                                                validations={null}
                                                loading={false}
                                            />
                                        </>
                                    </Col>
                                </Col>
                            </Container>
                        )}
                </MainContainer>
            </Fragment>
        );
    };

    render() {
        const { fetching, debinDetail, fetchingAccounts } = this.props;

        return (
            <Fragment>
                <PageLoading loading={fetching || fetchingAccounts}>
                    {!fetching && debinDetail && this.renderContent()}
                </PageLoading>
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    debinDetail: debinSelectors.getDebinDetail(state),
    loggedUser: sessionSelectors.getUser(state),
    fetchingAccounts: accountsSelectors.getFetching(state),
    accounts: accountsSelectors.getAccounts(state),
    fetching: debinSelectors.getFetching(state),
    isRetailEnvironment: sessionSelectors.isRetailEnvironment(state),
});

export default connect(mapStateToProps)(resizableRoute(IncomingDebinDetail));
